import { compose, applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import combinedReducers from './reducers';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { LOGOUT_SUCCESS } from './actions/types';

export let store;
let persistor;

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['filter', 'data', 'hashAuth'],
};

const rootReducer = (state, action) => {
  if (action.type === LOGOUT_SUCCESS) {
    storage.removeItem('persist:root');

    state = undefined;
  }

  return combinedReducers(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default (initialState) => {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  store = createStore(persistedReducer, initialState, composeEnhancers(applyMiddleware(thunk)));

  if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
      module.hot.accept('./reducers', () => {
        store.replaceReducer(persistedReducer);
      });
    }
    window.STORE = store;
  }

  persistor = persistStore(store);

  return { store, persistor };
};
